import { FC } from "react";
import { Box, CircularProgress } from "@mui/material";

export interface BusyLabelProps {
  label: string;
  busy: boolean;
  /** 진행 중일 때 보조 기술에 읽힐 문구(예: "저장 중"). */
  busyLabel: string;
  spinnerSize?: number;
}

/**
 * 버튼 라벨 자리를 그대로 둔 채 진행 중이면 스피너만 겹쳐 그린다 — 라벨 폭이 유지돼
 * 버튼과 옆 버튼이 움직이지 않는다. 공용 `Button` 의 `loading` 은 라벨을 다른 글자로
 * 바꿔 폭이 달라지므로 쓰지 않는다.
 */
export const BusyLabel: FC<BusyLabelProps> = ({
  label,
  busy,
  busyLabel,
  spinnerSize = 14,
}) => (
  <Box component="span" sx={{ position: "relative", display: "inline-flex" }}>
    <Box component="span" aria-hidden={busy} sx={{ visibility: busy ? "hidden" : "visible" }}>
      {label}
    </Box>
    {busy && (
      <Box
        component="span"
        role="status"
        aria-label={busyLabel}
        sx={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <CircularProgress size={spinnerSize} thickness={5} color="inherit" />
      </Box>
    )}
  </Box>
);
